import API from './api';

export default {
    
    getPrograms: (organization_id, visibility) => {
        let url = `programs?organization_id=${organization_id}`;
        if (visibility) {
            url += `&visibility=${visibility}`;
        }
        return API({
            url,
            method: 'GET',
        });
    },

    getProgram: (programId, organization_id) => API({
        url: `programs/${programId}?organization_id=${organization_id}`,
        method: 'GET',
    }),

    createProgram: (json) => API({
        url: 'programs',
        method: 'POST',
        json,
    }),

    updateProgram: (json) => API({
        url: `programs/${json.id}`,
        method: 'PATCH',
        json,
    }),

    deleteProgram: (id) => API({
        url: `programs/${id}`,
        method: 'DELETE',
    }),

    updateProgramSharing: (id, is_public) => API({
        url: `programs/${id}/sharing`,
        method: 'PATCH',
        json: { is_public },
    }),

    updateProgramContactEmail: (id, contact_email) => API({
        url: `programs/${id}/contact-email`,
        method: 'PATCH',
        json: { contact_email },
    }),

    getPublicProgram: (id) => API({
        url: `public/programs/${id}`,
        method: 'GET',
    }),

};
